function openFancyBox() {
	$("[data-fancybox]").fancybox({});
}